module.exports = __webpack_public_path__ + "media/images/team/BarbaraPereira-548eb6f30d0c80ecaf4ac7a209d53765.png";